export const TimeFields = {
    date: 'date',
    week: 'week',
    month: 'month',
    weekday: 'weekday',
};
